import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
import { AppComponent } from './app/app.component';
import { AuthModule } from './app/auth/auth.module';
import { routes } from './app/app.routes';
import { provideNgxMask } from 'ngx-mask';
import { provideAnimations } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';
import { ConfirmationService } from 'primeng/api';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

bootstrapApplication(AppComponent, {
  providers: [
    ConfirmationService,
    provideRouter(routes),
//    importProvidersFrom(AuthModule),
    provideNgxMask(),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([
        authInterceptor
      ])),
    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkMode: true,
          primary: 'teal'
        }
      }
    })
  ]
});
